var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_114",
    "data-name": "Group 114",
    transform: "translate(-197 -430)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Path_92",
    "data-name": "Path 92",
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.5c-2.633 0-5.186-.516-7.59-1.532-2.322-.982-4.408-2.388-6.199-4.18-1.79-1.79-3.197-3.876-4.179-6.198C1.016 25.186.5 22.633.5 20s.516-5.186 1.532-7.59c.982-2.322 2.388-4.408 4.18-6.199 1.79-1.79 3.876-3.197 6.198-4.179C14.814 1.016 17.367.5 20 .5s5.186.516 7.59 1.532c2.322.982 4.408 2.388 6.199 4.18 1.79 1.79 3.197 3.876 4.179 6.198C38.984 14.814 39.5 17.367 39.5 20s-.516 5.186-1.532 7.59c-.982 2.322-2.388 4.408-4.18 6.199-1.79 1.79-3.876 3.197-6.198 4.179C25.186 38.984 22.633 39.5 20 39.5z",
    style: {
      stroke: "none"
    },
    transform: "translate(197 430)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 1c-2.565 0-5.054.502-7.395 1.493-2.263.957-4.295 2.327-6.04 4.072s-3.115 3.777-4.072 6.04C1.503 14.946 1 17.435 1 20c0 2.565.502 5.054 1.493 7.395.957 2.263 2.327 4.295 4.072 6.04s3.777 3.115 6.04 4.072C14.946 38.497 17.435 39 20 39c2.565 0 5.054-.502 7.395-1.493 2.263-.957 4.295-2.327 6.04-4.072s3.115-3.777 4.072-6.04C38.497 25.054 39 22.565 39 20c0-2.565-.502-5.054-1.493-7.395-.957-2.263-2.327-4.295-4.072-6.04s-3.777-3.115-6.04-4.072C25.054 1.503 22.565 1 20 1m0-1c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0z",
    style: {
      fill: "#d5d5d6",
      stroke: "none"
    },
    transform: "translate(197 430)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_47",
    d: "M22.094 53.066c.016.219.016.438.016.656a14.261 14.261 0 0 1-14.36 14.36A14.262 14.262 0 0 1 0 65.816a10.441 10.441 0 0 0 1.219.062 10.107 10.107 0 0 0 6.266-2.156 5.056 5.056 0 0 1-4.719-3.5 6.365 6.365 0 0 0 .953.078 5.338 5.338 0 0 0 1.328-.172A5.048 5.048 0 0 1 1 55.176v-.062a5.083 5.083 0 0 0 2.281.641A5.054 5.054 0 0 1 1.719 49a14.346 14.346 0 0 0 10.406 5.281A5.7 5.7 0 0 1 12 53.129a5.052 5.052 0 0 1 8.734-3.453 9.936 9.936 0 0 0 3.2-1.219 5.033 5.033 0 0 1-2.219 2.781 10.117 10.117 0 0 0 2.906-.781 10.849 10.849 0 0 1-2.531 2.609z",
    "data-name": "Path 47",
    transform: "translate(205 391.918)",
    style: {
      fill: "#264f73"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.92846c0d.svg";
export { ForwardRef as ReactComponent };